// Client-side bounds for the router's /v1/build contract (audit #9). These MUST stay in sync with
// services/router/src/api/schemas.ts (slippageBps 1..5000, deadlineSeconds 30..3600). Converting and
// clamping here — before the user reaches submission — prevents a deterministic INVALID_REQUEST at
// signing time from an out-of-range slippage (e.g. a manual 0%) or deadline.
export const ROUTER_SLIPPAGE_BPS_MIN = 1
export const ROUTER_SLIPPAGE_BPS_MAX = 5000
export const ROUTER_DEADLINE_SECONDS_MIN = 30
export const ROUTER_DEADLINE_SECONDS_MAX = 3600
/** Default when slippage can't be derived (0/0 or NaN Percent): 0.5%. */
export const ROUTER_DEFAULT_SLIPPAGE_BPS = 50

function clamp(n: number, lo: number, hi: number): number {
  return Math.min(hi, Math.max(lo, n))
}

/**
 * Converts a `Percent` slippage (numerator/denominator as decimal strings) to integer bps, clamped to
 * the router's accepted range. A non-finite result falls back to the 0.5% default.
 */
export function toRouterSlippageBps(numerator: string, denominator: string): number {
  const raw = Math.round((Number(numerator) / Number(denominator)) * 10_000)
  if (!Number.isFinite(raw)) return ROUTER_DEFAULT_SLIPPAGE_BPS
  return clamp(raw, ROUTER_SLIPPAGE_BPS_MIN, ROUTER_SLIPPAGE_BPS_MAX)
}

/** Clamps a computed deadline (seconds from now) to the router's accepted range. */
export function toRouterDeadlineSeconds(seconds: number): number {
  if (!Number.isFinite(seconds)) return ROUTER_DEADLINE_SECONDS_MIN
  return clamp(Math.floor(seconds), ROUTER_DEADLINE_SECONDS_MIN, ROUTER_DEADLINE_SECONDS_MAX)
}
